// extracted by mini-css-extract-plugin
module.exports = {"comp":"HoverBtn_comp__k7WFq"};